import { createSelector } from 'reselect';
import { INVENTORY_TERMS_ACCEPTED } from 'swag-client-common/constants/local-storage-keys';
const userSelector = state => state.user;
const hasOwnDeletedInventorySelector = createSelector(userSelector, user => user.hasOwnDeletedInventories);
export const userHasInventoriesSelector = createSelector(userSelector, user => user.hasInventories);
export const isInventoryTermsAcceptedSelector = createSelector(userSelector, user => {
  const isAccepted = localStorage.getItem(INVENTORY_TERMS_ACCEPTED);
  return user.passedActions.inventoryTermAccepted || Boolean(isAccepted);
});
export const userHasActiveOrOwnDeletedInventorySelector = createSelector(userHasInventoriesSelector, hasOwnDeletedInventorySelector, (hasInventory, hasDeletedInventory) => hasInventory || hasDeletedInventory);
export const isUserPostalSupervisor = () => false;